import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "previous-module-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.6259 3.81342C18.9188 3.52053 19.3937 3.52053 19.6866 3.81342C19.9795 4.10631 19.9795 4.58119 19.6866 4.87408L12.6544 11.9062L19.6866 18.9384C19.9795 19.2313 19.9795 19.7062 19.6866 19.9991C19.3937 20.292 18.9188 20.292 18.6259 19.9991L11.0634 12.4366C10.7705 12.1437 10.7705 11.6688 11.0634 11.3759L18.6259 3.81342Z" }, null, -1),
    _createElementVNode("path", { d: "M5.59375 4.46875C5.59375 4.05454 5.92954 3.71875 6.34375 3.71875C6.75796 3.71875 7.09375 4.05454 7.09375 4.46875V19.6562C7.09375 20.0705 6.75796 20.4062 6.34375 20.4062C5.92954 20.4062 5.59375 20.0705 5.59375 19.6562V4.46875Z" }, null, -1)
  ])))
}
export default { render: render }